import { render, staticRenderFns } from "./genres.vue?vue&type=template&id=85240460&scoped=true"
import script from "./genres.vue?vue&type=script&lang=js"
export * from "./genres.vue?vue&type=script&lang=js"
import style0 from "./genres.vue?vue&type=style&index=0&id=85240460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85240460",
  null
  
)

export default component.exports